module.exports = __webpack_public_path__ + "img/mm-inv.59066c36.svg";